import moment, { Moment } from 'moment'
import { SalaryCalculationItem } from '../../../api/salaryCalculation'
import { CompensationCellVariant } from '../types/CompensationCellVariant'

export const getCompensationCellProps = (payoutDate: Moment, revenueItem?: SalaryCalculationItem) => {
  if (!revenueItem) return {}

  const compensationForMonthItemIndex = revenueItem?.payouts.findIndex((compensation) =>
    payoutDate.isSame(moment(compensation.date), 'month')
  )
  const compensationForMonthItem = revenueItem?.payouts[compensationForMonthItemIndex]
  const isInitial = compensationForMonthItemIndex === 0
  const compensationForMonthAmount = compensationForMonthItem?.amount

  const amountSign = compensationForMonthAmount > 0 ? 'positive' : compensationForMonthAmount < 0 ? 'negative' : 'zero'
  const variant: CompensationCellVariant = isInitial ? 'initial' : amountSign

  return { compensation: compensationForMonthAmount, variant }
}
